"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getFormData_node_1 = require("./getFormData.node");
function buildFormData(body) {
    var formData = getFormData_node_1.default();
    var isTriple = function (tuple) {
        return tuple[0] === 'file';
    };
    var _loop_1 = function (tuple) {
        if (Array.isArray(tuple[1])) {
            // refactor this
            tuple[1].forEach(function (val) { return val && formData.append(tuple[0] + '[]', "" + val); });
        }
        else if (isTriple(tuple)) {
            formData.append(tuple[0], tuple[1], tuple[2]);
        }
        else if (tuple[1] != null) {
            formData.append(tuple[0], "" + tuple[1]);
        }
    };
    for (var _i = 0, body_1 = body; _i < body_1.length; _i++) {
        var tuple = body_1[_i];
        _loop_1(tuple);
    }
    return formData;
}
exports.default = buildFormData;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@uploadcare/upload-client/lib/tools/buildFormData.js
// module id = 416
// module chunks = 71